import React from "react";
import "./Lines.css";

export default function AnimatedBackground({ children }) {
  const totalLines = 5;

  return (
    <div className="relative bg-[#163031] ">

      {/* Vertical lines container */}
      <div className="absolute inset-0">
        <div className="lines-wrapper hidden xl:block ">
          {[...Array(totalLines)].map((_, i) => (
            <div key={i} className="line">
              <span className="drop"></span>
              <span className="drop delay1"></span>
              <span className="drop delay2"></span>
            </div>
          ))}
        </div>
      </div>

      {children}
    </div>
  );
}
